


















import { Vue, Component, Prop } from 'vue-property-decorator';
import { IField } from '@/dealroom/fields/types/field';
import FieldContentContainer from '@/dealroom/fields/components/FieldContentContainer.vue';

@Component({
  components: {
    FieldContentContainer,
  },
})
export default class CheckboxField extends Vue {
  @Prop() field!: IField;
  @Prop() fullName: string;
  @Prop({ default: false }) isRequired: boolean;
  @Prop() showInitials: boolean;

  get isChecked(): boolean {
    return !!parseInt(this.field.value);
  }
}
